import { render, staticRenderFns } from "./feedbacktype.vue?vue&type=template&id=dbbdd742&scoped=true"
import script from "./feedbacktype.vue?vue&type=script&lang=js"
export * from "./feedbacktype.vue?vue&type=script&lang=js"
import style0 from "./feedbacktype.vue?vue&type=style&index=0&id=dbbdd742&lang=scss&scoped=true"
import style1 from "./feedbacktype.vue?vue&type=style&index=1&id=dbbdd742&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbdd742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbbdd742')) {
      api.createRecord('dbbdd742', component.options)
    } else {
      api.reload('dbbdd742', component.options)
    }
    module.hot.accept("./feedbacktype.vue?vue&type=template&id=dbbdd742&scoped=true", function () {
      api.rerender('dbbdd742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedback/feedbacktype.vue"
export default component.exports